import { useInterfaceStore } from 'src/stores/interface.js'

const GlobalNoticeList = {
  computed: {
    notices() {
      return useInterfaceStore().globalNotices
    },
  },
  methods: {
    closeNotice(notice) {
      useInterfaceStore().removeGlobalNotice(notice)
    },
    runAction(notice) {
      this.closeNotice(notice)
      notice.action.run()
    },
  },
}

export default GlobalNoticeList
